import {TransactionalNames} from '../enums/TransactionalNames.js';

/**
 * Powerup Perk base class.
 *
 * The powerup perks are implemented in a different way in Unity. Since we don't spawn
 * prefabs as easily as Unity. This works in a slightly different way.
 */
export abstract class PowerupPerk {
    abstract perkStat: TransactionalNames;
    abstract tagToAdjust: string;
    abstract execute(): void;
}
